export default __webpack_public_path__ + "static/media/854.4ef71276.png";